"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const extension_1 = require("../extension");
const for_1 = require("../token-parser/for");
const expression_parser_1 = require("../expression-parser");
const and_1 = require("../node/expression/binary/and");
const extends_1 = require("../token-parser/extends");
const from_1 = require("../token-parser/from");
const macro_1 = require("../token-parser/macro");
const node_1 = require("../node");
const in_1 = require("../node/expression/binary/in");
const if_1 = require("../token-parser/if");
const set_1 = require("../token-parser/set");
const block_1 = require("../token-parser/block");
const greater_1 = require("../node/expression/binary/greater");
const less_1 = require("../node/expression/binary/less");
const include_1 = require("../token-parser/include");
const with_1 = require("../token-parser/with");
const not_1 = require("../node/expression/unary/not");
const neg_1 = require("../node/expression/unary/neg");
const pos_1 = require("../node/expression/unary/pos");
const function_1 = require("../function");
const spaceless_1 = require("../token-parser/spaceless");
const concat_1 = require("../node/expression/binary/concat");
const mul_1 = require("../node/expression/binary/mul");
const div_1 = require("../node/expression/binary/div");
const floor_div_1 = require("../node/expression/binary/floor-div");
const mod_1 = require("../node/expression/binary/mod");
const sub_1 = require("../node/expression/binary/sub");
const add_1 = require("../node/expression/binary/add");
const use_1 = require("../token-parser/use");
const embed_1 = require("../token-parser/embed");
const filter_1 = require("../token-parser/filter");
const range_1 = require("../node/expression/binary/range");
const import_1 = require("../token-parser/import");
const do_1 = require("../token-parser/do");
const flush_1 = require("../token-parser/flush");
const equal_1 = require("../node/expression/binary/equal");
const not_equal_1 = require("../node/expression/binary/not-equal");
const or_1 = require("../node/expression/binary/or");
const bitwise_or_1 = require("../node/expression/binary/bitwise-or");
const bitwise_xor_1 = require("../node/expression/binary/bitwise-xor");
const bitwise_and_1 = require("../node/expression/binary/bitwise-and");
const greater_equal_1 = require("../node/expression/binary/greater-equal");
const less_equal_1 = require("../node/expression/binary/less-equal");
const not_in_1 = require("../node/expression/binary/not-in");
const null_coalesce_1 = require("../node/expression/null-coalesce");
const power_1 = require("../node/expression/binary/power");
const same_as_1 = require("../node/expression/test/same-as");
const defined_1 = require("../node/expression/test/defined");
const odd_1 = require("../node/expression/test/odd");
const constant_1 = require("../node/expression/test/constant");
const test_1 = require("../test");
const divisible_by_1 = require("../node/expression/test/divisible-by");
const matches_1 = require("../node/expression/binary/matches");
const starts_with_1 = require("../node/expression/binary/starts-with");
const ends_with_1 = require("../node/expression/binary/ends-with");
const filter_2 = require("../filter");
const luxon_1 = require("luxon");
const constant_2 = require("../node/expression/constant");
const default_1 = require("../node/expression/filter/default");
const null_1 = require("../node/expression/test/null");
const even_1 = require("../node/expression/test/even");
const min_1 = require("../helper/min");
const max_1 = require("../helper/max");
const is_traversable_1 = require("../helper/is-traversable");
const abs_1 = require("../helper/abs");
const json_encode_1 = require("../helper/json-encode");
const iconv_1 = require("../helper/iconv");
const runtime_1 = require("../error/runtime");
const iterator_to_array_1 = require("../helper/iterator-to-array");
const format_date_time_1 = require("../helper/format-date-time");
const format_duration_1 = require("../helper/format-duration");
const iterator_to_hash_1 = require("../helper/iterator-to-hash");
const util_1 = require("util");
const iterator_to_map_1 = require("../helper/iterator-to-map");
const compare_1 = require("../helper/compare");
const loader_1 = require("../error/loader");
const template_1 = require("../template");
const range_2 = require("../helper/range");
const relative_date_1 = require("../helper/relative-date");
const examine_object_1 = require("../helper/examine-object");
const chunk_1 = require("../helper/chunk");
const fill_1 = require("../helper/fill");
const merge_1 = require("../helper/merge");
const slice_1 = require("../helper/slice");
const asort_1 = require("../helper/asort");
const reverse_1 = require("../helper/reverse");
const first_1 = require("../helper/first");
const markup_1 = require("../markup");
const is_map_1 = require("../helper/is-map");
const spaceless_2 = require("../source-map/node/spaceless");
const node_2 = require("../source-map/node");
const deprecated_1 = require("../token-parser/deprecated");
const apply_1 = require("../token-parser/apply");
const sprintf = require('locutus/php/strings/sprintf');
const nl2br = require('locutus/php/strings/nl2br');
const strip_tags = require('locutus/php/strings/strip_tags');
const mt_rand = require('locutus/php/math/mt_rand');
const array_rand = require('locutus/php/array/array_rand');
const runes = require('runes');
const isFloat = require('locutus/php/var/is_float');
const isBool = require('locutus/php/var/is_bool');
const capitalize = require('capitalize');
const strtr = require('locutus/php/strings/strtr');
const round = require('locutus/php/math/round');
const ceil = require('locutus/php/math/ceil');
const floor = require('locutus/php/math/floor');
const isPlainObject = require('is-plain-object');
const bin2hex = require('locutus/php/strings/bin2hex');
const strlen = require('utf8-binary-cutter').getBinarySize;
const ltrim = require('locutus/php/strings/ltrim');
const rawurlencode = require('locutus/php/url/rawurlencode');
const htmlspecialchars = require('htmlspecialchars');
const array_merge = require('locutus/php/array/array_merge');
const locutusOrd = require('locutus/php/strings/ord');
const isObject = require('isobject');
class TwingExtensionCore extends extension_1.TwingExtension {
    constructor() {
        super(...arguments);
        this.dateFormats = ['F j, Y H:i', '%d days'];
        this.numberFormat = [0, '.', ','];
        this.timezone = null;
        this.escapers = new Map();
    }
    /**
     * Defines a new escaper to be used via the escape filter.
     *
     * @param {string} strategy     The strategy name that should be used as a strategy in the escape call
     * @param {Function} callable   A valid PHP callable
     */
    setEscaper(strategy, callable) {
        this.escapers.set(strategy, callable);
    }
    /**
     * Gets all defined escapers.
     *
     * @returns {Map<string, Function>}
     */
    getEscapers() {
        return this.escapers;
    }
    /**
     * Sets the default format to be used by the date filter.
     *
     * @param {string} format The default date format string
     * @param {string} dateIntervalFormat The default date interval format string
     */
    setDateFormat(format = null, dateIntervalFormat = null) {
        if (format !== null) {
            this.dateFormats[0] = format;
        }
        if (dateIntervalFormat !== null) {
            this.dateFormats[1] = dateIntervalFormat;
        }
    }
    /**
     * Gets the default format to be used by the date filter.
     *
     * @return array The default date format string and the default date interval format string
     */
    getDateFormat() {
        return this.dateFormats;
    }
    /**
     * Sets the default timezone to be used by the date filter.
     *
     * @param {string} timezone The default timezone string or a TwingDateTimeZone object
     */
    setTimezone(timezone) {
        this.timezone = timezone;
    }
    /**
     * Gets the default timezone to be used by the date filter.
     *
     * @returns {string} The default timezone currently in use
     */
    getTimezone() {
        if (this.timezone === null) {
            this.timezone = luxon_1.Settings.defaultZoneName;
        }
        return this.timezone;
    }
    /**
     * Sets the default format to be used by the number_format filter.
     *
     * @param {number} decimal the number of decimal places to use
     * @param {string} decimalPoint the character(s) to use for the decimal point
     * @param {string} thousandSep  the character(s) to use for the thousands separator
     */
    setNumberFormat(decimal, decimalPoint, thousandSep) {
        this.numberFormat = [decimal, decimalPoint, thousandSep];
    }
    /**
     * Get the default format used by the number_format filter.
     *
     * @return array The arguments for number_format()
     */
    getNumberFormat() {
        return this.numberFormat;
    }
    getTokenParsers() {
        return [
            new for_1.TwingTokenParserFor(),
            new if_1.TwingTokenParserIf(),
            new extends_1.TwingTokenParserExtends(),
            new include_1.TwingTokenParserInclude(),
            new block_1.TwingTokenParserBlock(),
            new use_1.TwingTokenParserUse(),
            new filter_1.TwingTokenParserFilter(),
            new macro_1.TwingTokenParserMacro(),
            new import_1.TwingTokenParserImport(),
            new from_1.TwingTokenParserFrom(),
            new set_1.TwingTokenParserSet(),
            new spaceless_1.TwingTokenParserSpaceless(),
            new flush_1.TwingTokenParserFlush(),
            new do_1.TwingTokenParserDo(),
            new embed_1.TwingTokenParserEmbed(),
            new with_1.TwingTokenParserWith(),
            new deprecated_1.TwingTokenParserDeprecated(),
            new apply_1.TwingTokenParserApply()
        ];
    }
    getFilters() {
        let i = 0;
        return new Map([
            // formatting filters
            [i++, new filter_2.TwingFilter('date', twingDateFormatFilter, { needs_environment: true })],
            [i++, new filter_2.TwingFilter('date_modify', twingDateModifyFilter, { needs_environment: true })],
            [i++, new filter_2.TwingFilter('format', sprintf)],
            [i++, new filter_2.TwingFilter('replace', twingReplaceFilter)],
            [i++, new filter_2.TwingFilter('number_format', twingNumberFormatFilter, {
                    needs_environment: true
                })],
            [i++, new filter_2.TwingFilter('abs', abs_1.abs)],
            [i++, new filter_2.TwingFilter('round', twingRound)],
            // encoding
            [i++, new filter_2.TwingFilter('url_encode', twingUrlencodeFilter)],
            [i++, new filter_2.TwingFilter('json_encode', json_encode_1.jsonEncode)],
            [i++, new filter_2.TwingFilter('convert_encoding', twingConvertEncoding, {
                    pre_escape: 'html',
                    is_safe: ['html']
                })],
            // string filters
            [i++, new filter_2.TwingFilter('title', twingTitleStringFilter, { needs_environment: true })],
            [i++, new filter_2.TwingFilter('capitalize', twingCapitalizeStringFilter, { needs_environment: true })],
            [i++, new filter_2.TwingFilter('upper', twingUpperFilter, { needs_environment: true })],
            [i++, new filter_2.TwingFilter('lower', twingLowerFilter, { needs_environment: true })],
            [i++, new filter_2.TwingFilter('striptags', strip_tags)],
            [i++, new filter_2.TwingFilter('trim', twingTrimFilter)],
            [i++, new filter_2.TwingFilter('nl2br', nl2br, {
                    pre_escape: 'html',
                    is_safe: ['html']
                })],
            [i++, new filter_2.TwingFilter('spaceless', twingSpacelessFilter, {
                    is_safe: ['html']
                })],
            // array helpers
            [i++, new filter_2.TwingFilter('join', twingJoinFilter)],
            [i++, new filter_2.TwingFilter('split', twingSplitFilter, { needs_environment: true })],
            [i++, new filter_2.TwingFilter('sort', twingSortFilter)],
            [i++, new filter_2.TwingFilter('merge', twingArrayMerge)],
            [i++, new filter_2.TwingFilter('batch', twingArrayBatch)],
            [i++, new filter_2.TwingFilter('column', twingColumnFilter)],
            [i++, new filter_2.TwingFilter('filter', twingFilterFilter)],
            [i++, new filter_2.TwingFilter('map', twingFilterMap)],
            [i++, new filter_2.TwingFilter('reduce', twingFilterReduce)],
            // string/array filters
            [i++, new filter_2.TwingFilter('reverse', twingReverseFilter, { needs_environment: true })],
            [i++, new filter_2.TwingFilter('length', twingLengthFilter, { needs_environment: true })],
            [i++, new filter_2.TwingFilter('slice', twingSlice, { needs_environment: true })],
            [i++, new filter_2.TwingFilter('first', twingFirst, { needs_environment: true })],
            [i++, new filter_2.TwingFilter('last', twingLast, { needs_environment: true })],
            // iteration and runtime
            [i++, new filter_2.TwingFilter('default', twingDefaultFilter, {
                    expression_factory: function (node, filterName, methodArguments, lineno, columnno, tag) {
                        return new default_1.TwingNodeExpressionFilterDefault(node, filterName, methodArguments, lineno, columnno, tag);
                    }
                })],
            [i++, new filter_2.TwingFilter('keys', twingGetArrayKeysFilter)],
            // escaping
            [i++, new filter_2.TwingFilter('escape', twingEscapeFilter, {
                    needs_environment: true,
                    is_safe_callback: twingEscapeFilterIsSafe
                })],
            [i++, new filter_2.TwingFilter('e', twingEscapeFilter, {
                    needs_environment: true,
                    is_safe_callback: twingEscapeFilterIsSafe
                })]
        ]);
    }
    getFunctions() {
        let i = 0;
        return new Map([
            [i++, new function_1.TwingFunction('max', max_1.max)],
            [i++, new function_1.TwingFunction('min', min_1.min)],
            [i++, new function_1.TwingFunction('range', range_2.range)],
            [i++, new function_1.TwingFunction('constant', twingConstant, { needs_environment: true })],
            [i++, new function_1.TwingFunction('cycle', twingCycle)],
            [i++, new function_1.TwingFunction('random', twingRandom, { needs_environment: true })],
            [i++, new function_1.TwingFunction('date', twingDateConverter, { needs_environment: true })],
            [i++, new function_1.TwingFunction('include', twingInclude, {
                    needs_context: true,
                    needs_environment: true,
                    needs_source: true,
                    is_safe: ['all']
                })],
            [i++, new function_1.TwingFunction('source', twingSource, {
                    needs_environment: true,
                    needs_source: true,
                    is_safe: ['all']
                })],
        ]);
    }
    getTests() {
        return [
            new test_1.TwingTest('even', null, {
                node_factory: function (node, name, nodeArguments, lineno, columnno) {
                    return new even_1.TwingNodeExpressionTestEven(node, name, nodeArguments, lineno, columnno);
                }
            }),
            new test_1.TwingTest('odd', null, {
                node_factory: function (node, name, nodeArguments, lineno, columnno) {
                    return new odd_1.TwingNodeExpressionTestOdd(node, name, nodeArguments, lineno, columnno);
                }
            }),
            new test_1.TwingTest('defined', null, {
                node_factory: function (node, name, nodeArguments, lineno, columnno) {
                    return new defined_1.TwingNodeExpressionTestDefined(node, name, nodeArguments, lineno, columnno);
                }
            }),
            new test_1.TwingTest('same as', null, {
                node_factory: function (node, name, nodeArguments, lineno, columnno) {
                    return new same_as_1.TwingNodeExpressionTestSameAs(node, name, nodeArguments, lineno, columnno);
                }
            }),
            new test_1.TwingTest('none', null, {
                node_factory: function (node, name, nodeArguments, lineno, columnno) {
                    return new null_1.TwingNodeExpressionTestNull(node, name, nodeArguments, lineno, columnno);
                }
            }),
            new test_1.TwingTest('null', null, {
                node_factory: function (node, name, nodeArguments, lineno, columnno) {
                    return new null_1.TwingNodeExpressionTestNull(node, name, nodeArguments, lineno, columnno);
                }
            }),
            new test_1.TwingTest('divisible by', null, {
                node_factory: function (node, name, nodeArguments, lineno, columnno) {
                    return new divisible_by_1.TwingNodeExpressionTestDivisibleBy(node, name, nodeArguments, lineno, columnno);
                }
            }),
            new test_1.TwingTest('constant', null, {
                node_factory: function (node, name, nodeArguments, lineno, columnno) {
                    return new constant_1.TwingNodeExpressionTestConstant(node, name, nodeArguments, lineno, columnno);
                }
            }),
            new test_1.TwingTest('empty', twingTestEmpty),
            new test_1.TwingTest('iterable', twingTestIterable)
        ];
    }
    getOperators() {
        return [
            new Map([
                ['not', {
                        precedence: 50,
                        factory: function (expr, lineno, columnno) {
                            return new not_1.TwingNodeExpressionUnaryNot(expr, lineno, columnno);
                        }
                    }],
                ['-', {
                        precedence: 500,
                        factory: function (expr, lineno, columnno) {
                            return new neg_1.TwingNodeExpressionUnaryNeg(expr, lineno, columnno);
                        }
                    }],
                ['+', {
                        precedence: 500,
                        factory: function (expr, lineno, columnno) {
                            return new pos_1.TwingNodeExpressionUnaryPos(expr, lineno, columnno);
                        }
                    }]
            ]),
            new Map([
                ['or', {
                        precedence: 10,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_LEFT,
                        factory: function (left, right, lineno, columnno) {
                            return new or_1.TwingNodeExpressionBinaryOr(left, right, lineno, columnno);
                        }
                    }],
                ['and', {
                        precedence: 15,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_LEFT,
                        factory: function (left, right, lineno, columnno) {
                            return new and_1.TwingNodeExpressionBinaryAnd(left, right, lineno, columnno);
                        }
                    }],
                ['b-or', {
                        precedence: 16,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_LEFT,
                        factory: function (left, right, lineno, columnno) {
                            return new bitwise_or_1.TwingNodeExpressionBinaryBitwiseOr(left, right, lineno, columnno);
                        }
                    }],
                ['b-xor', {
                        precedence: 17,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_LEFT,
                        factory: function (left, right, lineno, columnno) {
                            return new bitwise_xor_1.TwingNodeExpressionBinaryBitwiseXor(left, right, lineno, columnno);
                        }
                    }],
                ['b-and', {
                        precedence: 18,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_LEFT,
                        factory: function (left, right, lineno, columnno) {
                            return new bitwise_and_1.TwingNodeExpressionBinaryBitwiseAnd(left, right, lineno, columnno);
                        }
                    }],
                ['==', {
                        precedence: 20,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_LEFT,
                        factory: function (left, right, lineno, columnno) {
                            return new equal_1.TwingNodeExpressionBinaryEqual(left, right, lineno, columnno);
                        }
                    }],
                ['!=', {
                        precedence: 20,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_LEFT,
                        factory: function (left, right, lineno, columnno) {
                            return new not_equal_1.TwingNodeExpressionBinaryNotEqual(left, right, lineno, columnno);
                        }
                    }],
                ['<', {
                        precedence: 20,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_LEFT,
                        factory: function (left, right, lineno, columnno) {
                            return new less_1.TwingNodeExpressionBinaryLess(left, right, lineno, columnno);
                        }
                    }],
                ['>', {
                        precedence: 20,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_LEFT,
                        factory: function (left, right, lineno, columnno) {
                            return new greater_1.TwingNodeExpressionBinaryGreater(left, right, lineno, columnno);
                        }
                    }],
                ['>=', {
                        precedence: 20,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_LEFT,
                        factory: function (left, right, lineno, columnno) {
                            return new greater_equal_1.TwingNodeExpressionBinaryGreaterEqual(left, right, lineno, columnno);
                        }
                    }],
                ['<=', {
                        precedence: 20,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_LEFT,
                        factory: function (left, right, lineno, columnno) {
                            return new less_equal_1.TwingNodeExpressionBinaryLessEqual(left, right, lineno, columnno);
                        }
                    }],
                ['not in', {
                        precedence: 20,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_LEFT,
                        factory: function (left, right, lineno, columnno) {
                            return new not_in_1.TwingNodeExpressionBinaryNotIn(left, right, lineno, columnno);
                        }
                    }],
                ['in', {
                        precedence: 20,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_LEFT,
                        factory: function (left, right, lineno, columnno) {
                            return new in_1.TwingNodeExpressionBinaryIn(left, right, lineno, columnno);
                        }
                    }],
                ['matches', {
                        precedence: 20,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_LEFT,
                        factory: function (left, right, lineno, columnno) {
                            return new matches_1.TwingNodeExpressionBinaryMatches(left, right, lineno, columnno);
                        }
                    }],
                ['starts with', {
                        precedence: 20,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_LEFT,
                        factory: function (left, right, lineno, columnno) {
                            return new starts_with_1.TwingNodeExpressionBinaryStartsWith(left, right, lineno, columnno);
                        }
                    }],
                ['ends with', {
                        precedence: 20,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_LEFT,
                        factory: function (left, right, lineno, columnno) {
                            return new ends_with_1.TwingNodeExpressionBinaryEndsWith(left, right, lineno, columnno);
                        }
                    }],
                ['..', {
                        precedence: 25,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_LEFT,
                        factory: function (left, right, lineno, columnno) {
                            return new range_1.TwingNodeExpressionBinaryRange(left, right, lineno, columnno);
                        }
                    }],
                ['+', {
                        precedence: 30,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_LEFT,
                        factory: function (left, right, lineno, columnno) {
                            return new add_1.TwingNodeExpressionBinaryAdd(left, right, lineno, columnno);
                        }
                    }],
                ['-', {
                        precedence: 30,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_LEFT,
                        factory: function (left, right, lineno, columnno) {
                            return new sub_1.TwingNodeExpressionBinarySub(left, right, lineno, columnno);
                        }
                    }],
                ['~', {
                        precedence: 40,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_LEFT,
                        factory: function (left, right, lineno, columnno) {
                            return new concat_1.TwingNodeExpressionBinaryConcat(left, right, lineno, columnno);
                        }
                    }],
                ['*', {
                        precedence: 60,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_LEFT,
                        factory: function (left, right, lineno, columnno) {
                            return new mul_1.TwingNodeExpressionBinaryMul(left, right, lineno, columnno);
                        }
                    }],
                ['/', {
                        precedence: 60,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_LEFT,
                        factory: function (left, right, lineno, columnno) {
                            return new div_1.TwingNodeExpressionBinaryDiv(left, right, lineno, columnno);
                        }
                    }],
                ['//', {
                        precedence: 60,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_LEFT,
                        factory: function (left, right, lineno, columnno) {
                            return new floor_div_1.TwingNodeExpressionBinaryFloorDiv(left, right, lineno, columnno);
                        }
                    }],
                ['%', {
                        precedence: 60,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_LEFT,
                        factory: function (left, right, lineno, columnno) {
                            return new mod_1.TwingNodeExpressionBinaryMod(left, right, lineno, columnno);
                        }
                    }],
                ['is', {
                        precedence: 100,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_LEFT,
                        factory: null
                    }],
                ['is not', {
                        precedence: 100,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_LEFT,
                        factory: null
                    }],
                ['**', {
                        precedence: 200,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_RIGHT,
                        factory: function (left, right, lineno, columnno) {
                            return new power_1.TwingNodeExpressionBinaryPower(left, right, lineno, columnno);
                        }
                    }],
                ['??', {
                        precedence: 300,
                        associativity: expression_parser_1.TwingExpressionParser.OPERATOR_RIGHT,
                        factory: function (left, right, lineno, columnno) {
                            return new null_coalesce_1.TwingNodeExpressionNullCoalesce(left, right, lineno, columnno);
                        }
                    }]
            ])
        ];
    }
    /**
     * @param {TwingNodeType} type
     * @returns {TwingSourceMapNodeConstructor}
     */
    getSourceMapNodeConstructor(type) {
        switch (type) {
            case node_1.TwingNodeType.SPACELESS: {
                return spaceless_2.TwingSourceMapNodeSpaceless;
            }
            default: {
                return node_2.TwingSourceMapNode;
            }
        }
    }
}
exports.TwingExtensionCore = TwingExtensionCore;
/**
 * Cycles over a value.
 *
 * @param {Array} values
 * @param {number} position The cycle position
 *
 * @returns {string} The next value in the cycle
 */
function twingCycle(values, position) {
    if (!Array.isArray(values)) {
        return values;
    }
    return values[position % values.length];
}
exports.twingCycle = twingCycle;
/**
 * Returns a random value depending on the supplied parameter type:
 * - a random item from a Traversable or array
 * - a random character from a string
 * - a random integer between 0 and the integer parameter.
 *
 * @param {TwingEnvironment} env
 * @param {*} values The values to pick a random item from
 * @param {number} max Maximum value used when values is an integer
 * @throws TwingErrorRuntime when values is an empty array (does not apply to an empty string which is returned as is)
 *
 * @returns {*} A random value from the given sequence
 */
function twingRandom(env, values = null, max = null) {
    if (values === null) {
        return max === null ? mt_rand() : mt_rand(0, max);
    }
    if (typeof values === 'number') {
        let min;
        if (max === null) {
            if (values < 0) {
                max = 0;
                min = values;
            }
            else {
                max = values;
                min = 0;
            }
        }
        else {
            min = values;
        }
        return mt_rand(min, max);
    }
    if (typeof values === 'string') {
        values = Buffer.from(values);
    }
    if (Buffer.isBuffer(values)) {
        if (values.toString() === '') {
            return '';
        }
        let charset = env.getCharset();
        if (charset !== 'UTF-8') {
            values = iconv_1.iconv(charset, 'UTF-8', values);
        }
        // unicode split
        values = runes(values.toString());
        if (charset !== 'UTF-8') {
            values = values.map(function (value) {
                return iconv_1.iconv('UTF-8', charset, Buffer.from(value));
            });
        }
    }
    else if (is_traversable_1.isTraversable(values)) {
        values = iterator_to_array_1.iteratorToArray(values);
    }
    if (!Array.isArray(values)) {
        return values;
    }
    if (values.length < 1) {
        throw new runtime_1.TwingErrorRuntime('The random function cannot pick from an empty array.');
    }
    return values[array_rand(values, 1)];
}
exports.twingRandom = twingRandom;
/**
 * Converts a date to the given format.
 *
 * <pre>
 *   {{ post.published_at|date("m/d/Y") }}
 * </pre>
 *
 * @param {TwingEnvironment} env
 * @param {DateTime|Duration|string} date A date
 * @param {string|null} format The target format, null to use the default
 * @param {string|null|false} timezone The target timezone, null to use the default, false to leave unchanged
 *
 * @return string The formatted date
 */
function twingDateFormatFilter(env, date, format = null, timezone = null) {
    if (format === null) {
        let coreExtension = env.getExtension('TwingExtensionCore');
        let formats = coreExtension.getDateFormat();
        format = date instanceof luxon_1.Duration ? formats[1] : formats[0];
    }
    date = twingDateConverter(env, date, timezone);
    if (date instanceof luxon_1.Duration) {
        return format_duration_1.formatDuration(date, format);
    }
    return format_date_time_1.formatDateTime(date, format);
}
exports.twingDateFormatFilter = twingDateFormatFilter;
/**
 * Returns a new date object modified.
 *
 * <pre>
 *   {{ post.published_at|date_modify("-1day")|date("m/d/Y") }}
 * </pre>
 *
 * @param {TwingEnvironment} env
 * @param {DateTime|Duration|string} date A date
 * @param {string} modifier A modifier string
 *
 * @returns {DateTime} A new date object
 */
function twingDateModifyFilter(env, date, modifier) {
    let dateTime = twingDateConverter(env, date);
    let regExp = new RegExp(/(\+|-)([0-9])(.*)/);
    let parts = regExp.exec(modifier);
    let operator = parts[1];
    let operand = Number.parseInt(parts[2]);
    let unit = parts[3].trim();
    let duration = {};
    duration[unit] = operator === '-' ? -operand : operand;
    dateTime = dateTime.plus(duration);
    return dateTime;
}
exports.twingDateModifyFilter = twingDateModifyFilter;
/**
 * Converts an input to a DateTime instance.
 *
 * <pre>
 *    {% if date(user.created_at) < date('+2days') %}
 *      {# do something #}
 *    {% endif %}
 * </pre>
 *
 * @param {TwingEnvironment} env
 * @param {Date | DateTime | Duration | number | string} date A date or null to use the current time
 * @param {string | null | false} timezone The target timezone, null to use the default, false to leave unchanged
 *
 * @returns {DateTime} A DateTime instance
 */
function twingDateConverter(env, date, timezone = null) {
    let result;
    let coreExtension = env.getExtension('TwingExtensionCore');
    // determine the timezone
    if (timezone !== false) {
        if (timezone === null) {
            timezone = coreExtension.getTimezone();
        }
    }
    if (date instanceof luxon_1.DateTime) {
        if (timezone !== false) {
            date = date.setZone(timezone);
        }
        return date;
    }
    if (date instanceof luxon_1.Duration) {
        return date;
    }
    let parsedUtcOffset = 0;
    if (!date) {
        result = luxon_1.DateTime.local();
    }
    else if (date instanceof Date) {
        result = luxon_1.DateTime.fromJSDate(date);
    }
    else if (typeof date === 'string') {
        if (date === 'now') {
            result = luxon_1.DateTime.local();
        }
        else {
            result = luxon_1.DateTime.fromISO(date, { setZone: true });
            if (!result.isValid) {
                result = luxon_1.DateTime.fromRFC2822(date, { setZone: true });
            }
            if (!result.isValid) {
                result = luxon_1.DateTime.fromSQL(date, { setZone: true });
            }
            if (result.isValid) {
                parsedUtcOffset = result.offset;
            }
            else {
                result = relative_date_1.relativeDate(date);
            }
        }
    }
    else if (typeof date === 'number') {
        // date is PHP timestamp - i.e. in seconds
        let ts = date * 1000;
        // timestamp are UTC by definition
        result = luxon_1.DateTime.fromMillis(ts, {
            setZone: false
        });
    }
    if (!result || !result.isValid) {
        throw new runtime_1.TwingErrorRuntime(`Failed to parse date "${date}".`);
    }
    if (timezone !== false) {
        result = result.setZone(timezone);
    }
    else {
        if (parsedUtcOffset) {
            // explicit UTC offset
            result = result.setZone(`UTC+${parsedUtcOffset / 60}`);
        }
    }
    Reflect.set(result, 'format', function (format) {
        return format_date_time_1.formatDateTime(this, format);
    });
    return result;
}
exports.twingDateConverter = twingDateConverter;
/**
 * Replaces strings within a string.
 *
 * @param {string} str  String to replace in
 * @param {Array<string>|Map<string, string>} from Replace values
 *
 * @returns {string}
 */
function twingReplaceFilter(str, from) {
    if (is_traversable_1.isTraversable(from)) {
        from = iterator_to_hash_1.iteratorToHash(from);
    }
    else if (typeof from !== 'object') {
        throw new runtime_1.TwingErrorRuntime(`The "replace" filter expects an hash or "Iterable" as replace values, got "${typeof from}".`);
    }
    return strtr(str, from);
}
exports.twingReplaceFilter = twingReplaceFilter;
/**
 * Rounds a number.
 *
 * @param value The value to round
 * @param {number} precision The rounding precision
 * @param {string} method The method to use for rounding
 *
 * @returns int|float The rounded number
 */
function twingRound(value, precision = 0, method = 'common') {
    if (method === 'common') {
        return round(value, precision);
    }
    if (method !== 'ceil' && method !== 'floor') {
        throw new runtime_1.TwingErrorRuntime('The round filter only supports the "common", "ceil", and "floor" methods.');
    }
    let intermediateValue = value * Math.pow(10, precision);
    let intermediateDivider = Math.pow(10, precision);
    switch (method) {
        case 'ceil':
            return ceil(intermediateValue) / intermediateDivider;
        default:
            return floor(intermediateValue) / intermediateDivider;
    }
}
exports.twingRound = twingRound;
/**
 * Number format filter.
 *
 * All of the formatting options can be left null, in that case the defaults will
 * be used.  Supplying any of the parameters will override the defaults set in the
 * environment object.
 *
 * @param {TwingEnvironment} env
 * @param {*} number A float/int/string of the number to format
 * @param {number} decimal the number of decimal points to display
 * @param {string} decimalPoint the character(s) to use for the decimal point
 * @param {string} thousandSep the character(s) to use for the thousands separator
 *
 * @returns string The formatted number
 */
function twingNumberFormatFilter(env, number, decimal, decimalPoint, thousandSep) {
    const number_format = require('locutus/php/strings/number_format');
    let coreExtension = env.getExtension('TwingExtensionCore');
    let defaults = coreExtension.getNumberFormat();
    if (util_1.isNullOrUndefined(decimal)) {
        decimal = defaults[0];
    }
    if (util_1.isNullOrUndefined(decimalPoint)) {
        decimalPoint = defaults[1];
    }
    if (util_1.isNullOrUndefined(thousandSep)) {
        thousandSep = defaults[2];
    }
    return number_format(number, decimal, decimalPoint, thousandSep);
}
exports.twingNumberFormatFilter = twingNumberFormatFilter;
/**
 * URL encodes (RFC 3986) a string as a path segment or a hash as a query string.
 *
 * @param {string|{}} url A URL or a hash of query parameters
 *
 * @returns {string} The URL encoded value
 */
function twingUrlencodeFilter(url) {
    const http_build_query = require('locutus/php/url/http_build_query');
    if (typeof url !== 'string') {
        if (is_traversable_1.isTraversable(url)) {
            url = iterator_to_hash_1.iteratorToHash(url);
        }
        let builtUrl = http_build_query(url, '', '&');
        return builtUrl.replace(/\+/g, '%20');
    }
    return encodeURIComponent(url);
}
exports.twingUrlencodeFilter = twingUrlencodeFilter;
/**
 * Merges an array with another one.
 *
 * <pre>
 *  {% set items = { 'apple': 'fruit', 'orange': 'fruit' } %}
 *
 *  {% set items = items|merge({ 'peugeot': 'car' }) %}
 *
 *  {# items now contains { 'apple': 'fruit', 'orange': 'fruit', 'peugeot': 'car' } #}
 * </pre>
 *
 * @param {*} arr1 An array
 * @param {*} arr2 An array
 *
 * @return array The merged array
 */
function twingArrayMerge(arr1, arr2) {
    if (util_1.isNullOrUndefined(arr1) || (!is_traversable_1.isTraversable(arr1) && (typeof arr1 !== 'object'))) {
        throw new runtime_1.TwingErrorRuntime(`The merge filter only works with arrays or "Traversable", got "${!util_1.isNullOrUndefined(arr1) ? typeof arr1 : arr1}" as first argument.`);
    }
    if (util_1.isNullOrUndefined(arr2) || (!is_traversable_1.isTraversable(arr2) && (typeof arr2 !== 'object'))) {
        throw new runtime_1.TwingErrorRuntime(`The merge filter only works with arrays or "Traversable", got "${!util_1.isNullOrUndefined(arr2) ? typeof arr2 : arr2}" as second argument.`);
    }
    return merge_1.merge(arr1, arr2);
}
exports.twingArrayMerge = twingArrayMerge;
/**
 * Slices a variable.
 *
 * @param {TwingEnvironment} env
 * @param item A variable
 * @param {number} start Start of the slice
 * @param {number} length Size of the slice
 * @param {boolean} preserveKeys Whether to preserve key or not (when the input is an object)
 *
 * @returns The sliced variable
 */
function twingSlice(env, item, start, length = null, preserveKeys = false) {
    if (is_traversable_1.isTraversable(item)) {
        let iterableItem = iterator_to_map_1.iteratorToMap(item);
        if (length === null) {
            length = iterableItem.size - start;
        }
        return slice_1.slice(iterableItem, start, length, preserveKeys);
    }
    item = '' + (item ? item : '');
    if (length === null) {
        length = item.length - start;
    }
    return item.substr(start, length);
}
exports.twingSlice = twingSlice;
/**
 * Returns the first element of the item.
 *
 * @param {TwingEnvironment} env
 * @param {*} item A variable
 *
 * @returns {*} The first element of the item
 */
function twingFirst(env, item) {
    let elements = twingSlice(env, item, 0, 1, false);
    return typeof elements === 'string' ? elements : first_1.first(elements);
}
exports.twingFirst = twingFirst;
/**
 * Returns the last element of the item.
 *
 * @param {TwingEnvironment} env
 * @param item A variable
 *
 * @returns The last element of the item
 */
function twingLast(env, item) {
    let elements = twingSlice(env, item, -1, 1, false);
    return typeof elements === 'string' ? elements : first_1.first(elements);
}
exports.twingLast = twingLast;
/**
 * Joins the values to a string.
 *
 * The separator between elements is an empty string per default, you can define it with the optional parameter.
 *
 * <pre>
 *  {{ [1, 2, 3]|join('|') }}
 *  {# returns 1|2|3 #}
 *
 *  {{ [1, 2, 3]|join }}
 *  {# returns 123 #}
 * </pre>
 *
 * @param {Array<*>} value An array
 * @param {string} glue The separator
 * @param {string | null} and The separator for the last pair
 *
 * @returns {string} The concatenated string
 */
function twingJoinFilter(value, glue = '', and = null) {
    if (util_1.isNullOrUndefined(value)) {
        return '';
    }
    if (is_traversable_1.isTraversable(value)) {
        value = iterator_to_array_1.iteratorToArray(value, false);
        // this is ugly but we have to ensure that each element of the array is rendered as PHP would render it
        // this is mainly useful for booleans that are not rendered the same way in PHP and JavaScript
        let safeValue = value.map(function (item) {
            if (typeof item === 'boolean') {
                return (item === true) ? '1' : '';
            }
            return item;
        });
        if (and === null || and === glue) {
            return safeValue.join(glue);
        }
        if (safeValue.length === 1) {
            return safeValue[0];
        }
        return safeValue.slice(0, -1).join(glue) + and + safeValue[safeValue.length - 1];
    }
    return '';
}
exports.twingJoinFilter = twingJoinFilter;
/**
 * Splits the string into an array.
 *
 * <pre>
 *  {{ "one,two,three"|split(',') }}
 *  {# returns [one, two, three] #}
 *
 *  {{ "one,two,three,four,five"|split(',', 3) }}
 *  {# returns [one, two, "three,four,five"] #}
 *
 *  {{ "123"|split('') }}
 *  {# returns [1, 2, 3] #}
 *
 *  {{ "aabbcc"|split('', 2) }}
 *  {# returns [aa, bb, cc] #}
 * </pre>
 *
 * @param {TwingEnvironment} env
 * @param {string} value A string
 * @param {string} delimiter The delimiter
 * @param {number} limit The limit
 *
 * @returns {Array<string>} The split string as an array
 */
function twingSplitFilter(env, value, delimiter, limit) {
    const explode = require('locutus/php/strings/explode');
    if (delimiter) {
        return !limit ? explode(delimiter, value) : explode(delimiter, value, limit);
    }
    if (!limit || limit <= 1) {
        return value.match(/.{1,1}/ug);
    }
    let length = value.length;
    if (length < limit) {
        return [value];
    }
    let r = [];
    for (let i = 0; i < length; i += limit) {
        r.push(value.substr(i, limit));
    }
    return r;
}
exports.twingSplitFilter = twingSplitFilter;
// The '_default' filter is used internally to avoid using the ternary operator
// which costs a lot for big contexts (before PHP 5.4). So, on average,
// a function call is cheaper.
/**
 * @internal
 */
function twingDefaultFilter(value, defaultValue = '') {
    if (twingTestEmpty(value)) {
        return defaultValue;
    }
    return value;
}
exports.twingDefaultFilter = twingDefaultFilter;
/**
 * Returns the keys for the given array.
 *
 * It is useful when you want to iterate over the keys of an array:
 *
 * <pre>
 *  {% for key in array|keys %}
 *      {# ... #}
 *  {% endfor %}
 * </pre>
 *
 * @param {Array<*>} array An array
 *
 * @returns {Array<*>} The keys
 */
function twingGetArrayKeysFilter(array) {
    let traversable;
    if (util_1.isNullOrUndefined(array)) {
        traversable = new Map();
    }
    else {
        traversable = iterator_to_map_1.iteratorToMap(array);
    }
    return [...traversable.keys()];
}
exports.twingGetArrayKeysFilter = twingGetArrayKeysFilter;
/**
 * Reverses a variable.
 *
 * @param {TwingEnvironment} env
 * @param {string | Map<*, *>} item A traversable instance, or a string
 * @param {boolean} preserveKeys Whether to preserve key or not
 *
 * @returns The reversed input
 */
function twingReverseFilter(env, item, preserveKeys = false) {
    if (typeof item === 'string') {
        let esrever = require('esrever');
        return esrever.reverse(item);
    }
    else {
        return reverse_1.reverse(iterator_to_map_1.iteratorToMap(item), preserveKeys);
    }
}
exports.twingReverseFilter = twingReverseFilter;
/**
 * Sorts an array.
 *
 * @param {Array<*>} array
 *
 * @returns {Map<*,*>}
 */
function twingSortFilter(array) {
    if (!is_traversable_1.isTraversable(array) && !Array.isArray(array)) {
        throw new runtime_1.TwingErrorRuntime(`The sort filter only works with iterables, got "${typeof array}".`);
    }
    let map = iterator_to_map_1.iteratorToMap(array);
    asort_1.asort(map);
    return map;
}
exports.twingSortFilter = twingSortFilter;
/**
 * @internal
 */
function twingInFilter(value, compare) {
    let result = false;
    if (value instanceof markup_1.TwingMarkup) {
        value = value.toString();
    }
    if (Array.isArray(compare)) {
        for (let item of compare) {
            if (compare_1.compare(item, value)) {
                result = true;
                break;
            }
        }
    }
    else if (typeof compare === 'string' && (typeof value === 'string' || typeof value === 'number')) {
        result = (value === '' || compare.includes('' + value));
    }
    else if (is_traversable_1.isTraversable(compare)) {
        for (let item of iterator_to_array_1.iteratorToArray(compare)) {
            if (compare_1.compare(item, value)) {
                result = true;
                break;
            }
        }
    }
    else if (typeof compare === 'object') {
        for (let key in compare) {
            if (compare_1.compare(compare[key], value)) {
                result = true;
                break;
            }
        }
    }
    return result;
}
exports.twingInFilter = twingInFilter;
/**
 * Returns a trimmed string.
 *
 * @returns {string}
 *
 * @throws TwingErrorRuntime When an invalid trimming side is used (not a string or not 'left', 'right', or 'both')
 */
function twingTrimFilter(string, characterMask = null, side = 'both') {
    const trim = require('locutus/php/strings/trim');
    const ltrim = require('locutus/php/strings/ltrim');
    const rtrim = require('locutus/php/strings/rtrim');
    if (characterMask === null) {
        characterMask = " \t\n\r\0\x0B";
    }
    switch (side) {
        case 'both':
            return trim(string, characterMask);
        case 'left':
            return ltrim(string, characterMask);
        case 'right':
            return rtrim(string, characterMask);
        default:
            throw new runtime_1.TwingErrorRuntime('Trimming side must be "left", "right" or "both".');
    }
}
exports.twingTrimFilter = twingTrimFilter;
/**
 * Removes whitespaces between HTML tags.
 *
 * @return string
 */
function twingSpacelessFilter(content) {
    return content.toString().replace(/>\s+</g, '><').trim();
}
exports.twingSpacelessFilter = twingSpacelessFilter;
/**
 * Escapes a string.
 *
 * @param {TwingEnvironment} env
 * @param {*} string The value to be escaped
 * @param {string} strategy The escaping strategy
 * @param {string} charset The charset
 * @param {boolean} autoescape Whether the function is called by the auto-escaping feature (true) or by the developer (false)
 *
 * @returns {string}
 */
function twingEscapeFilter(env, string, strategy = 'html', charset = null, autoescape = false) {
    if (autoescape && string && string instanceof markup_1.TwingMarkup) {
        return string;
    }
    if (typeof string !== 'string') {
        if (string && (typeof string === 'object') && Reflect.has(string, 'toString')) {
            string = '' + string;
        }
        else if (['html', 'js', 'css', 'html_attr', 'url'].includes(strategy)) {
            return string;
        }
    }
    if (string === '') {
        return '';
    }
    if (charset === null) {
        charset = env.getCharset();
    }
    let regExp = /^[.\s\S]/u;
    switch (strategy) {
        case 'html':
            return htmlspecialchars(string);
        case 'js':
            // escape all non-alphanumeric characters
            // into their \x or \uHHHH representations
            // if (charset !== 'UTF-8') {
            //     string = iconv(charset, 'UTF-8', string).toString();
            // }
            // unit: no test case for this
            // if ((strlen(string) === 0) ? false : !regExp.test(string)) {
            //     throw new TwingErrorRuntime('The string to escape is not a valid UTF-8 string.');
            // }
            string = string.replace(/[^a-zA-Z0-9,\._]/ug, function (matches) {
                let char = matches;
                /**
                 * A few characters have short escape sequences in JSON and JavaScript.
                 * Escape sequences supported only by JavaScript, not JSON, are ommitted.
                 * \" is also supported but omitted, because the resulting string is not HTML safe.
                 */
                let shortMap = new Map([
                    ['\\', '\\\\'],
                    ['/', '\\/'],
                    ["\x08", '\\b'],
                    ["\x0C", '\\f'],
                    ["\x0A", '\\n'],
                    ["\x0D", '\\r'],
                    ["\x09", '\\t'],
                ]);
                if (shortMap.has(char)) {
                    return shortMap.get(char);
                }
                // \uHHHH
                char = bin2hex(char).toUpperCase();
                if (strlen(char) <= 4) {
                    return sprintf('\\u%04s', char);
                }
                return sprintf('\\u%04s\\u%04s', char.substr(0, 4), char.substr(4, 4));
            });
            // if (charset !== 'UTF-8') {
            //     string = iconv('UTF-8', charset, string).toString();
            // }
            return string;
        case 'css':
            // if (charset !== 'UTF-8') {
            //     string = iconv(charset, 'UTF-8', string).toString();
            // }
            // unit: no test case for this
            // if ((strlen(string) === 0) ? false : !regExp.test(string)) {
            //     throw new TwingErrorRuntime('The string to escape is not a valid UTF-8 string.');
            // }
            string = string.replace(/[^a-zA-Z0-9]/ug, function (matches) {
                let char = matches;
                // \xHH
                if (strlen(char) === 1) {
                    let hex = ltrim(bin2hex(char).toUpperCase(), '0');
                    if (strlen(hex) === 0) {
                        hex = '0';
                    }
                    return '\\' + hex + ' ';
                }
                // \uHHHH
                return '\\' + ltrim(bin2hex(char).toUpperCase(), '0') + ' ';
            });
            // if (charset !== 'UTF-8') {
            //     string = iconv('UTF-8', charset, string).toString();
            // }
            return string;
        case 'html_attr':
            // if (charset !== 'UTF-8') {
            //     string = iconv(charset, 'UTF-8', string).toString();
            // }
            // unit: no test case for this
            // if ((strlen(string) === 0) ? false : !regExp.test(string)) {
            //     throw new TwingErrorRuntime('The string to escape is not a valid UTF-8 string.');
            // }
            string = string.replace(/[^a-zA-Z0-9,\.\-_]/ug, function (matches) {
                /**
                 * This function is adapted from code coming from Zend Framework.
                 *
                 * @copyright Copyright (c) 2005-2012 Zend Technologies USA Inc. (http://www.zend.com)
                 * @license   http://framework.zend.com/license/new-bsd New BSD License
                 */
                /*
                 * While HTML supports far more named entities, the lowest common denominator
                 * has become HTML5's XML Serialisation which is restricted to the those named
                 * entities that XML supports. Using HTML entities would result in this error:
                 *     XML Parsing Error: undefined entity
                 */
                let entityMap = new Map([
                    [34, 'quot'],
                    [38, 'amp'],
                    [60, 'lt'],
                    [62, 'gt'] /* greater-than sign */
                ]);
                let chr = matches;
                let ord = locutusOrd(chr);
                /*
                 * The following replaces characters undefined in HTML with the
                 * hex entity for the Unicode replacement character.
                 */
                if ((ord <= 0x1f && chr != "\t" && chr != "\n" && chr != "\r") || (ord >= 0x7f && ord <= 0x9f)) {
                    return '&#xFFFD;';
                }
                /*
                 * Check if the current character to escape has a name entity we should
                 * replace it with while grabbing the hex value of the character.
                 */
                let int = chr.codePointAt(0);
                if (entityMap.has(int)) {
                    return `&${entityMap.get(int)};`;
                }
                let hex = int.toString(16).toUpperCase();
                if (hex.length === 1 || hex.length === 3) {
                    hex = '0' + hex;
                }
                /*
                 * Per OWASP recommendations, we'll use hex entities for any other
                 * characters where a named entity does not exist.
                 */
                return `&#x${hex};`;
            });
            // if (charset !== 'UTF-8') {
            //     string = iconv('UTF-8', charset, string).toString();
            // }
            return string;
        case 'url':
            return rawurlencode(string);
        default:
            let coreExtension = env.getExtension('TwingExtensionCore');
            let escapers = coreExtension.getEscapers();
            if (escapers.has(strategy)) {
                return escapers.get(strategy)(env, string, charset);
            }
            let validStrategies = array_merge(['html', 'js', 'url', 'css', 'html_attr'], [...escapers.keys()]);
            throw new runtime_1.TwingErrorRuntime(`Invalid escaping strategy "${strategy}" (valid ones: ${validStrategies.join(', ')}).`);
    }
}
exports.twingEscapeFilter = twingEscapeFilter;
/**
 * @internal
 */
function twingEscapeFilterIsSafe(filterArgs) {
    if (filterArgs.getNodes().size > 0) {
        let result = [];
        filterArgs.getNodes().forEach(function (arg) {
            if (arg instanceof constant_2.TwingNodeExpressionConstant) {
                result = [arg.getAttribute('value')];
            }
        });
        return result;
    }
    else {
        return ['html'];
    }
}
exports.twingEscapeFilterIsSafe = twingEscapeFilterIsSafe;
function twingConvertEncoding(string, to, from) {
    return iconv_1.iconv(from, to, Buffer.from(string));
}
exports.twingConvertEncoding = twingConvertEncoding;
/**
 * Returns the length of a variable.
 *
 * @param {TwingEnvironment} env A TwingEnvironment instance
 * @param thing A variable
 *
 * @returns {number} The length of the value
 */
function twingLengthFilter(env, thing) {
    if (util_1.isNullOrUndefined(thing)) {
        return 0;
    }
    if (thing.length) {
        return thing.length;
    }
    if (thing.size) {
        return thing.size;
    }
    if (thing.toString && (typeof thing.toString === 'function')) {
        return thing.toString().length;
    }
    return 1;
}
exports.twingLengthFilter = twingLengthFilter;
/**
 * Converts a string to uppercase.
 *
 * @param {TwingEnvironment} env
 * @param {string | TwingMarkup} string A string
 *
 * @returns {string} The uppercased string
 */
function twingUpperFilter(env, string) {
    // todo: use charset
    if (typeof string !== 'string') {
        string = string.toString();
    }
    return string.toUpperCase();
}
exports.twingUpperFilter = twingUpperFilter;
/**
 * Converts a string to lowercase.
 *
 * @param {TwingEnvironment} env
 * @param {string} string A string
 *
 * @returns {string} The lowercased string
 */
function twingLowerFilter(env, string) {
    // todo: use charset
    return (typeof string === 'string') ? string.toLowerCase() : string;
}
exports.twingLowerFilter = twingLowerFilter;
/**
 * Returns a titlecased string.
 *
 * @param {TwingEnvironment} env
 * @param {string | TwingMarkup} string A string
 *
 * @returns {string} The titlecased string
 */
function twingTitleStringFilter(env, string) {
    const ucwords = require('locutus/php/strings/ucwords');
    return ucwords(string.toString().toLowerCase());
}
exports.twingTitleStringFilter = twingTitleStringFilter;
/**
 * Returns a capitalized string.
 *
 * @param {TwingEnvironment} env
 * @param {string} string A string
 *
 * @returns {string} The capitalized string
 */
function twingCapitalizeStringFilter(env, string) {
    return capitalize(string);
}
exports.twingCapitalizeStringFilter = twingCapitalizeStringFilter;
/**
 * @internal
 */
function twingEnsureTraversable(seq) {
    if (is_traversable_1.isTraversable(seq) || isPlainObject(seq)) {
        return seq;
    }
    return [];
}
exports.twingEnsureTraversable = twingEnsureTraversable;
/**
 * Checks if a variable is empty.
 *
 * <pre>
 * {# evaluates to true if the foo variable is null, false, or the empty string #}
 * {% if foo is empty %}
 *     {# ... #}
 * {% endif %}
 * </pre>
 *
 * @param value A variable
 *
 * @returns {boolean} true if the value is empty, false otherwise
 */
function twingTestEmpty(value) {
    if (value === null || value === undefined) {
        return true;
    }
    if (typeof value[Symbol.iterator] === 'function') {
        return value[Symbol.iterator]().next().done === true;
    }
    if (typeof value === 'object' && value.toString && typeof value.toString === 'function') {
        return value.toString().length < 1;
    }
    return value === false;
}
exports.twingTestEmpty = twingTestEmpty;
/**
 * Checks if a variable is traversable.
 *
 * <pre>
 * {# evaluates to true if the foo variable is an array or a traversable object #}
 * {% if foo is iterable %}
 *     {# ... #}
 * {% endif %}
 * </pre>
 *
 * @param value A variable
 *
 * @return {boolean} true if the value is traversable
 */
function twingTestIterable(value) {
    // in PHP a string is not traversable
    if (typeof value === 'string') {
        return false;
    }
    if (typeof value[Symbol.iterator] === 'function') {
        return true;
    }
    // in PHP objects are not iterable so we have to ensure that the test reflects that
    return false;
}
exports.twingTestIterable = twingTestIterable;
/**
 * Renders a template.
 *
 * @param {TwingEnvironment} env
 * @param {Map<*,*>} context
 * @param {TwingSource} source
 * @param {string|Array<string>} template The template to render or an array of templates to try consecutively
 * @param variables The variables to pass to the template
 * @param {boolean} withContext
 * @param {boolean} ignoreMissing Whether to ignore missing templates or not
 * @param {boolean} sandboxed Whether to sandbox the template or not
 *
 * @returns {string} The rendered template
 */
function twingInclude(env, context, source, template, variables = {}, withContext = true, ignoreMissing = false, sandboxed = false) {
    let alreadySandboxed = false;
    let sandbox = null;
    variables = iterator_to_map_1.iteratorToMap(variables);
    if (withContext) {
        variables = merge_1.merge(context, variables);
    }
    let isSandboxed = sandboxed && env.hasExtension('TwingExtensionSandbox');
    if (isSandboxed) {
        sandbox = env.getExtension('TwingExtensionSandbox');
        if (!(alreadySandboxed = sandbox.isSandboxed())) {
            sandbox.enableSandbox();
        }
    }
    let loaded = null;
    try {
        loaded = env.resolveTemplate(template, source);
    }
    catch (e) {
        if (e instanceof loader_1.TwingErrorLoader) {
            if (!ignoreMissing) {
                if (sandbox && !alreadySandboxed) {
                    sandbox.disableSandbox();
                }
                throw e;
            }
        }
        else {
            if (sandbox && !alreadySandboxed) {
                sandbox.disableSandbox();
            }
            throw e;
        }
    }
    let result;
    try {
        result = loaded ? loaded.render(variables) : '';
    }
    finally {
        if (sandbox && !alreadySandboxed) {
            sandbox.disableSandbox();
        }
    }
    return result;
}
exports.twingInclude = twingInclude;
/**
 * Returns a template content without rendering it.
 *
 * @param {TwingEnvironment} env
 * @param {TwingSource} source
 * @param {string} name The template name
 * @param {boolean} ignoreMissing Whether to ignore missing templates or not
 *
 * @return string The template source
 */
function twingSource(env, source, name, ignoreMissing = false) {
    let loader = env.getLoader();
    try {
        return loader.getSourceContext(name, source).getCode();
    }
    catch (e) {
        if (e instanceof loader_1.TwingErrorLoader) {
            if (!ignoreMissing) {
                throw e;
            }
        }
        else {
            throw e;
        }
    }
    return null;
}
exports.twingSource = twingSource;
/**
 * Provides the ability to get constants from instances as well as class/global constants.
 *
 * Constant function makes no sense in JavaScript. To emulate the expected behavior, it is assumed that
 * so-called constants are keys of the TwingEnvironment.globals property.
 *
 * @param {TwingEnvironment} env The environment
 * @param {string} constant The name of the constant
 * @param object The object to get the constant from
 *
 * @returns {string}
 */
function twingConstant(env, constant, object) {
    let globals = env.getGlobals();
    let bucket;
    if (object && typeof object === 'object') {
        let className = object.constructor.name;
        bucket = globals.get(className);
    }
    else {
        bucket = globals;
    }
    return bucket.get(constant);
}
exports.twingConstant = twingConstant;
/**
 * Batches item.
 *
 * @param {Array} items An array of items
 * @param {number} size  The size of the batch
 * @param {any} fill A value used to fill missing items
 * @param {boolean} preserveKeys
 *
 * @returns Array<any>
 */
function twingArrayBatch(items, size, fill = null, preserveKeys = true) {
    if (util_1.isNullOrUndefined(items)) {
        return [];
    }
    let chunks = chunk_1.chunk(items, size, preserveKeys);
    if (fill !== null && chunks.length) {
        let last = chunks.length - 1;
        let lastChunk = chunks[last];
        fill_1.fill(lastChunk, size, fill);
    }
    return chunks;
}
exports.twingArrayBatch = twingArrayBatch;
/**
 * Returns the attribute value for a given array/object.
 *
 * @param {TwingEnvironment} env
 * @param {*} object The object or array from where to get the item
 * @param {*} item The item to get from the array or object
 * @param {Array<*>} _arguments An array of arguments to pass if the item is an object method
 * @param {string} type The type of attribute (@see Twig_Template constants)
 * @param {boolean} isDefinedTest Whether this is only a defined check
 * @param {boolean} ignoreStrictCheck Whether to ignore the strict attribute check or not
 * @param {boolean} sandboxed
 *
 * @returns mixed The attribute value, or a Boolean when $isDefinedTest is true, or null when the attribute is not set and $ignoreStrictCheck is true
 *
 * @throws TwingErrorRuntime if the attribute does not exist and Twig is running in strict mode and $isDefinedTest is false
 *
 * @internal
 */
function twingGetAttribute(env, object, item, _arguments = [], type = template_1.TwingTemplate.ANY_CALL, isDefinedTest = false, ignoreStrictCheck = false, sandboxed = false) {
    let message;
    // ANY_CALL or ARRAY_CALL
    if (type !== template_1.TwingTemplate.METHOD_CALL) {
        let arrayItem;
        if (isBool(item)) {
            arrayItem = item ? 1 : 0;
        }
        else if (isFloat(item)) {
            arrayItem = parseInt(item);
        }
        else {
            arrayItem = item;
        }
        if (object) {
            if (Array.isArray(object) && (typeof object[arrayItem] !== 'undefined')) {
                if (isDefinedTest) {
                    return true;
                }
                return object[arrayItem];
            }
            else if (is_map_1.isMap(object) && object.has(arrayItem)) {
                if (isDefinedTest) {
                    return true;
                }
                return object.get(item);
            }
            else if (isPlainObject(object) && Reflect.has(object, arrayItem) && (typeof Reflect.get(object, arrayItem) !== 'function')) {
                if (isDefinedTest) {
                    return true;
                }
                return Reflect.get(object, item);
            }
        }
        if ((type === template_1.TwingTemplate.ARRAY_CALL) || (Array.isArray(object)) || (object instanceof Map) || (object === null) || (typeof object !== 'object')) {
            if (isDefinedTest) {
                return false;
            }
            if (ignoreStrictCheck || !env.isStrictVariables()) {
                return;
            }
            if (Array.isArray(object)) {
                // object is an array
                if (object.length < 1) {
                    message = `Index "${arrayItem}" is out of bounds as the array is empty.`;
                }
                else {
                    message = `Index "${arrayItem}" is out of bounds for array [${object}].`;
                }
            }
            else if (is_map_1.isMap(object)) {
                // object is a map
                message = `Impossible to access a key ("${item}") on a ${typeof object} variable ("${object.toString()}").`;
            }
            else if (type === template_1.TwingTemplate.ARRAY_CALL) {
                // object is another kind of object
                if (object === null) {
                    message = `Impossible to access a key ("${item}") on a null variable.`;
                }
                else {
                    message = `Impossible to access a key ("${item}") on a ${typeof object} variable ("${object.toString()}").`;
                }
            }
            else if (object === null) {
                // object is null
                message = `Impossible to access an attribute ("${item}") on a null variable.`;
            }
            else {
                // object is a primitive
                message = `Impossible to access an attribute ("${item}") on a ${typeof object} variable ("${object}").`;
            }
            throw new runtime_1.TwingErrorRuntime(message);
        }
    }
    // ANY_CALL or METHOD_CALL
    if ((object === null) || (!isObject(object))) {
        // object is a primitive
        if (isDefinedTest) {
            return false;
        }
        if (ignoreStrictCheck || !env.isStrictVariables()) {
            return;
        }
        if (object === null) {
            message = `Impossible to invoke a method ("${item}") on a null variable.`;
        }
        else if (Array.isArray(object)) {
            message = `Impossible to invoke a method ("${item}") on an array.`;
        }
        else {
            message = `Impossible to invoke a method ("${item}") on a ${typeof object} variable ("${object}").`;
        }
        throw new runtime_1.TwingErrorRuntime(message);
    }
    if (object instanceof template_1.TwingTemplate) {
        throw new runtime_1.TwingErrorRuntime('Accessing TwingTemplate attributes is forbidden.');
    }
    // object property
    if (type !== template_1.TwingTemplate.METHOD_CALL) {
        if (Reflect.has(object, item) && (typeof object[item] !== 'function')) {
            if (isDefinedTest) {
                return true;
            }
            if (sandboxed) {
                let extension = env.getExtension('TwingExtensionSandbox');
                extension.checkPropertyAllowed(object, item);
            }
            return object[item];
        }
    }
    // object method
    // precedence: getXxx() > isXxx() > hasXxx()
    let methods = [];
    for (let property of examine_object_1.examineObject(object)) {
        let candidate = object[property];
        if (typeof candidate === 'function') {
            methods.push(property);
        }
    }
    methods.sort();
    let lcMethods = methods.map((method) => {
        return method.toLowerCase();
    });
    let candidates = new Map();
    for (let i = 0; i < methods.length; i++) {
        let method = methods[i];
        let lcName = lcMethods[i];
        candidates.set(method, method);
        candidates.set(lcName, method);
        let name;
        if (lcName[0] === 'g' && lcName.indexOf('get') === 0) {
            name = method.substr(3);
            lcName = lcName.substr(3);
        }
        else if (lcName[0] === 'i' && lcName.indexOf('is') === 0) {
            name = method.substr(2);
            lcName = lcName.substr(2);
        }
        else if (lcName[0] === 'h' && lcName.indexOf('has') === 0) {
            name = method.substr(3);
            lcName = lcName.substr(3);
            if (lcMethods.includes('is' + lcName)) {
                continue;
            }
        }
        else {
            continue;
        }
        // skip get() and is() methods (in which case, name is empty)
        if (name) {
            if (!candidates.has(name)) {
                candidates.set(name, method);
            }
            if (!candidates.has(lcName)) {
                candidates.set(lcName, method);
            }
        }
    }
    let itemAsString = item;
    let method = null;
    let lcItem;
    if (candidates.has(item)) {
        method = candidates.get(item);
    }
    else if (candidates.has(lcItem = itemAsString.toLowerCase())) {
        method = candidates.get(lcItem);
    }
    else {
        if (isDefinedTest) {
            return false;
        }
        if (ignoreStrictCheck || !env.isStrictVariables()) {
            return;
        }
        throw new runtime_1.TwingErrorRuntime(`Neither the property "${item}" nor one of the methods ${item}()" or "get${item}()"/"is${item}()"/"has${item}()" exist and have public access in class "${object.constructor.name}".`);
    }
    if (isDefinedTest) {
        return true;
    }
    if (sandboxed) {
        let extension = env.getExtension('TwingExtensionSandbox');
        extension.checkMethodAllowed(object, method);
    }
    return Reflect.get(object, method).apply(object, _arguments);
}
exports.twingGetAttribute = twingGetAttribute;
/**
 * Return the values from a single column in the input array.
 *
 * <pre>
 *  {% set items = [{ 'fruit' : 'apple'}, {'fruit' : 'orange' }] %}
 *
 *  {% set fruits = items|column('fruit') %}
 *
 *  {# fruits now contains ['apple', 'orange'] #}
 * </pre>
 *
 * @param {*} thing An iterable
 * @param {*} columnKey The column key
 *
 * @return Array<any> The array of values
 */
function twingColumnFilter(thing, columnKey) {
    let map;
    if (!is_traversable_1.isTraversable(thing) || isPlainObject(thing)) {
        throw new runtime_1.TwingErrorRuntime(`The column filter only works with arrays or "Traversable", got "${typeof thing}" as first argument.`);
    }
    else {
        map = iterator_to_map_1.iteratorToMap(thing);
    }
    let result = [];
    for (let value of map.values()) {
        let valueAsMap = iterator_to_map_1.iteratorToMap(value);
        for (let [key, value] of valueAsMap) {
            if (key === columnKey) {
                result.push(value);
            }
        }
    }
    return result;
}
exports.twingColumnFilter = twingColumnFilter;
function twingFilterFilter(map, callback) {
    let result = new Map();
    map = iterator_to_map_1.iteratorToMap(map);
    for (let [k, v] of map) {
        if (callback(v)) {
            result.set(k, v);
        }
    }
    return result;
}
exports.twingFilterFilter = twingFilterFilter;
function twingFilterMap(map, callback) {
    let result = new Map();
    map = iterator_to_map_1.iteratorToMap(map);
    for (let [k, v] of map) {
        v = callback(v);
        result.set(k, v);
    }
    return result;
}
exports.twingFilterMap = twingFilterMap;
function twingFilterReduce(map, callback, initial = null) {
    map = iterator_to_map_1.iteratorToMap(map);
    let values = Array.from(map.values());
    return values.reduce((previousValue, currentValue) => {
        return callback(previousValue, currentValue);
    }, initial);
}
exports.twingFilterReduce = twingFilterReduce;
